import apiClient from "../../utils/clients/axios";

// get all issue data
export const getReportIssueData = async () => {
  const response = await apiClient.get(`/api/quality_control/report_issue`);
  return response;
};

// get pending issue data
export const getReportPendingIssueData = async () => {
  const response = await apiClient.get(
    `/api/quality_control/report_issue/getPendingIssue`
  );
  return response;
};

// one page of pending issues of the managers the logged-in user supervises;
// params: pageSize, slNo, hall, solution, and direction / cursorKey /
// cursorSlNo for pages after the first. data: [...] like the other getters
export const getApprovalIssueData = async (params = {}) => {
  const response = await apiClient.get(
    `/api/quality_control/report_issue/approvals`,
    { params }
  );
  const {
    issues = [],
    total = 0,
    offset = 0,
    hasPrev = false,
    hasNext = false,
  } = response?.data || {};
  return { data: issues, total, offset, hasPrev, hasNext };
};

// one full issue (images and solutions), for the approver's detail dialog
export const getIssueDetails = async (id) => {
  const response = await apiClient.get(
    `/api/quality_control/report_issue/${id}`
  );
  return response?.data;
};

// whether the logged-in user approves any reporting manager's solutions
export const getApprovalStatus = async () => {
  const response = await apiClient.get(
    `/api/quality_control/report_issue/approvals/status`
  );
  return Boolean(response?.data?.isApprover);
};

// superior accepts or declines one manager's solution (remarks required)
export const decideSolution = async ({ id, managerId, decision, remarks }) => {
  const response = await apiClient.put(
    `/api/quality_control/report_issue/${id}/approval`,
    { managerId, decision, remarks }
  );
  return response;
};

// update for 'accept' or 'decline'
export const updateERP = async (params) => {
  const { payload, id } = params;
  const response = await apiClient.put(
    `/api/quality_control/report_issue/${id}`,
    payload
  );
  return response;
};
